export default __webpack_public_path__ + "static/svyazON-696f7ace89395ce55da1c65768fdaf23.jpg";